export const SKU_LOCAL_STORAGE_KEY = "sku";
export const DISTRIBUTOR_LOCAL_STORAGE_KEY = "distributor";

export const MAX_DISTRIBUTORS_IN_URL = 120;
export const INTERNAL_SKU_LOCAL_STORAGE_KEY = "internalSku";
